import { atom } from "recoil";

export const isDarkAtom = atom({
  key: "isDarK",
  default: true,
});
